//
//   const { data } = openapi.usePostMultiplacerDevicesQuery(args ?? skipToken);

import { createSelector } from "@reduxjs/toolkit";
import { openapi } from "../../../openapi";
import { IRootState } from "../../app/store";
import { selectGetDevicesArgs } from "../designSlice";
import { IDevice } from "@backend/src/schemas";

export const EMPTY_DEVICES: IDevice[] = [];
/** Hämtar query-resultatet (senaste i cachen) för nuvarande args */
export const selectHttpDevices = (state: IRootState) => {
  const args = selectGetDevicesArgs(state);
  if (!args) return EMPTY_DEVICES;
  return openapi.endpoints.postMultiplacerDevices.select(args)(state).data ?? EMPTY_DEVICES;
};

export const selectNrOfDevices = createSelector([selectHttpDevices], (devices) => {
  return devices.length;
});

export const selectDeviceById = (state: IRootState, id: string | undefined) => {
  const devices = selectHttpDevices(state);
  if (!id) return undefined;
  return devices.find((d) => d._id === id);
};
